import { baseResourceOptions } from './utils';
import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import { ExternalAppsTemplate } from 'src/models/Sidekick/SidekickExternalAppsTemplate';

const sidekickExternalAppsTemplatesResource = createCollectionResource<ExternalAppsTemplate>({
  name: 'sidekickExternalAppsTemplates',
  endpoint: 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows-next/external-apps/templates',
  type: ExternalAppsTemplate,
  observerCreator: emptyObserverCreator,
  options: {
    ...baseResourceOptions,
    transformDataBeforeStore: <ExternalAppsTemplate>(data: unknown): ExternalAppsTemplate[] => {
      const rawData = data as { data: { appTemplates: ExternalAppsTemplate[] } };
      return rawData.data.appTemplates;
    },
  },
});

export default sidekickExternalAppsTemplatesResource;
